import * as React from 'react';
import classnames from 'classnames';

import { Grid, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { useI18n } from '@hydra/common/customHooks';
import { Image, Button, Translate } from '@hydra/common/components';

import technicalSeoBlue from '@hydra/assets/img/review/technical-seo-blue.svg';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
    display: 'flex',
    border: `1px solid ${theme.palette.grey[200]}`,
    padding: theme.spacing(4),
    columnGap: theme.spacing(1),
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      rowGap: theme.spacing(4)
    }
  },
  media: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  image: {
    width: '100%',
    [theme.breakpoints.down('xs')]: {
      width: '50%'
    }
  },
  content: {
    paddingLeft: theme.spacing(2),
    [theme.breakpoints.down('xs')]: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  },
  my1: {
    margin: theme.spacing(1, 0)
  },
  success: {
    borderLeft: `5px solid ${theme.palette.success.main}`
  },
  warning: {
    borderLeft: `5px solid ${theme.palette.warning.main}`
  },
  error: {
    borderLeft: `5px solid ${theme.palette.error.main}`
  },
  grey: {
    borderLeft: `5px solid ${theme.palette.grey[400]}`
  }
}));

export default function ReviewTeaserCTACard ({ color }: { color: 'success' | 'warning' | 'error' | 'grey' }) {
  const classes = useStyles();
  const { locale } = useI18n();
  return (
    <div className={classnames(classes.root, classes[color])}>
      <Grid item md={2} sm={2} xs={12} className={classes.media}>
        <Image className={classes.image} src={technicalSeoBlue} />
      </Grid>
      <Grid item md={10} sm={10} xs={12} className={classes.content}>
        <Typography
          variant='h5'
          color='textPrimary'
          className={classes.my1}
        >
          <Translate content='teaser_review_cta_title' />
        </Typography>
        <Typography
          variant='body2'
          color='textSecondary'
          className={classes.my1}
        >
          <Translate content='teaser_review_cta_description' />
        </Typography>
        <Button
          variant='contained'
          color='success'
          size='large'
          href={`/${locale}/register/plan/v2pro`}
          className={classes.my1}
        >
          <Translate content='teaser_review_cta_start_my_free_trial' />
        </Button>
      </Grid>
    </div>
  );
}
